<template>
  <div class="section">
    <div class="section-head">
      <img src="~@/assets/img/itles-webapp-videoClass/title-dg.png" alt />
    </div>
    <p class="total">共{{ list["days"] }}天</p>
    <div class="section-conect">
      <ul class="ul">
        <li v-for="(item, index) in list['day']" :key="index" class="item">
          <span class="number">{{ index | filterNum }}</span>
          <ul class="item-ul">
            <li v-for="(_item, index) in item" :key="index" class="item-ul-li">
              <div class="title">
                {{ _item.name }}
                <span v-if="item.length > 1" class="caption">{{
                  "任务" + (index + 1)
                }}</span>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {};
  },
  filters: {
    filterNum: num => {
      return `Day ${num}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.section-head {
  img {
    display: block;
    width: tovw(368);
    height: tovw(48);
    margin: tovw(40) auto;
    margin-top: tovw(80);
    margin-bottom: tovw(20);
  }
}
.total {
  font-size: tovw(28);
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.8);
  line-height: tovw(40);
  text-align: center;
  margin-bottom: tovw(40);
}
.section-conect {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  border-radius: tovw(24);
  .ul {
    margin: 0 tovw(40) 0 tovw(150);
    .item {
      position: relative;
      border-bottom: 1px solid rgba(221,221,221,.4);
      padding: tovw(30) 0;
      .number {
        position: absolute;
        top: tovw(36);
        left: tovw(-151);
        display: block;
        text-align: center;
        width: tovw(130);
        height: tovw(40);
        background: url(~@/assets/img/itles-webapp-videoClass/icon-label-dg-1.png)
          no-repeat;
        background-size: 100% 100%;
        font-size: tovw(30);
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: tovw(40);
      }
      .item-ul-li {
        margin-bottom: tovw(10);
        overflow: hidden;
        .title {
          box-sizing: border-box;
          padding-right: tovw(80);
          font-size: tovw(34);
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: rgba(0, 0, 0, 0.8);
          line-height: tovw(48);
          position: relative;
          .caption {
            position: absolute;
            top: tovw(4);
            right: 0;
            line-height: tovw(32);
            background: rgba(102, 168, 29, 0.08);
            border-radius: tovw(8);
            color: #66a81d;
            font-size: tovw(22);
            padding: tovw(4) tovw(6);
          }
        }
      }
      .item-ul-li:last-child {
        margin-bottom: 0;
      }
    }
    .item:last-child {
      border: none;
    }
  }
}
</style>
